import { render } from "./CalendarComponent.vue?vue&type=template&id=01478b5e&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=01478b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01478b5e"]])

export default __exports__